import React, { useState, useEffect } from "react";
import {
  //  Button, 
  Popover } from "antd";
import { 
  CopyOutlined, 
  XOutlined,
  WhatsAppOutlined,
  FacebookOutlined
} from "@ant-design/icons";

import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

type ShareProps = {
  shareUrl: string;
  shareEmailSubject: string;
  quote: string;
  hashtag: string;
  title: string;
  summary: string;
  source?: string;
  hashtags: string[];
  relatedAccounts?: string[];
  popoverTitle?: string;
  width?: number;
  children?: React.ReactNode;
};

const CopyIcon = ({ url, setTitle, initial }: { url: string; setTitle: (t: string) => void; initial: string }) => {
  const copy = () => {
    navigator.clipboard.writeText(url);
    setTitle("Copied!");
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setTitle(initial);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [initial, setTitle]);

  return (
    <button
      className="react-share__ShareButton"
      onClick={copy}
      style={{
        backgroundColor: "#fff",
        height: "20px",
        width: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        font: "inherit",
        cursor: "pointer",
        position: "relative",
      }}
      type="button"
    >
      <CopyOutlined style={{ fontSize: 15 }} />
    </button>
  );
};


//   shareUrl,
//   shareEmailSubject,
//   quote,
//   hashtag,
//   title,
//   summary,
//   source = "Njoy",
//   hashtags,
//   relatedAccounts,
// }) => {
//   const [text, setText] = useState("Share via");

//   const shareContent = (
//     <div className="flex items-center border-8">
//       <FacebookShareButton url={shareUrl} hashtag={hashtag}>
//         <FacebookIcon size={30} />
//       </FacebookShareButton>
//       <TwitterShareButton
//         url={shareUrl}
//         title={title}
//         via="Njoy"
//         hashtags={hashtags}
//         related={relatedAccounts}
//       >
//         <TwitterIcon size={30} />
//       </TwitterShareButton>
//       <CopyIcon url={shareUrl} setTitle={setText} initial="Share via" />
//     </div>
//   );

//   return (
//     <Popover
//       title={text}
//       content={shareContent}
//       trigger="click"
//       className="share-btns"
//     >
//       <Button type="primary" className="btn_dark_icon">
//         <i className="material-icons">share</i>
//       </Button>
//     </Popover>
//   );
// };

export const ShareWrapper: React.FC<ShareProps> = ({
  children,
  shareUrl,
  shareEmailSubject,
  quote,
  hashtag,
  title,
  summary,
  source = "Njoy",
  hashtags,
  relatedAccounts,
  popoverTitle = "",
  width = 220,
}) => {
  const [text, setText] = useState(popoverTitle);

  const shareContent = (
    <div className="flex items-center justify-between">
      <FacebookShareButton url={shareUrl} hashtag={hashtag}>
        <FacebookOutlined size={35} />
      </FacebookShareButton>
      <TwitterShareButton
        url={shareUrl}
        title={title}
        via="Njoydotlive"
        hashtags={hashtags}
        related={relatedAccounts}
      >
        <XOutlined size={35} />
      </TwitterShareButton>
      <WhatsappShareButton url={shareUrl} title={title}>
        <WhatsAppOutlined size={35} />
      </WhatsappShareButton>
      <CopyIcon url={shareUrl} setTitle={setText} initial={popoverTitle} />
    </div>
  );

  return (
    <Popover
      placement="topRight"
      title={text}
      content={shareContent}
      trigger="click"
      overlayStyle={{ width }}
      className="share-btns text-center "
    >
      {children}
    </Popover>
  );
};